import { render, staticRenderFns } from "./Bhe.vue?vue&type=template&id=c316199e"
import script from "./Bhe.vue?vue&type=script&lang=js"
export * from "./Bhe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports